import React, { useEffect, useState } from 'react';
import {
  Breadcrumb,
  Button,
  Checkbox,
  Container,
  Divider,
  Input,
  InputGroup,
  InputNumber,
  Loader,
  Message,
  Pagination,
  Panel,
  SelectPicker,
  Stack,
  Table,
  toaster,
  Tooltip,
  Whisper
} from 'rsuite';
import {
  fetchColors,
  fetchFinishes,
  fetchHsn,
  fetchMaterials,
  fetchCategory,
  fetchSkuUnique,
  fetchAlias,
  fetchBuyers,
  fetchMadeBy,
  fetchHeads,
  fetchProductLabel,
  fetchProductDesign,
  fetchProductName,
  fetchSearchKeyword,
  fetchProductTypes
} from '../../../apiService/apiService';
import SearchIcon from '@rsuite/icons/Search';
import ugr from '@/UGRoute';
import globalIP from '@/GlobelIP';
import HeaderFilter from '@/components/HeaderFilter';
import FilterDrawer from '@/components/FilterDrawer';
import { Link } from 'react-router-dom';

const data = ['Regular', 'Buyer'].map(item => ({ label: item, value: item }));

const { HeaderCell, Cell } = Table;
const PriceList = () => {
  const [label, setLabel] = useState([]);
  useEffect(() => {
    fetchProductLabel(setLabel);
  }, []);
  const [costinghead, setCostingHead] = useState({
    L: 0,
    M: 0,
    X: 0
  });
  useEffect(() => {
    fetchData11();
  }, []);
  const fetchData11 = async () => {
    try {
      const response = await fetch(`${globalIP}/api/costingheads?populate=*`);
      const jsonData = await response.json();
      // Assuming you have a valid data structure
      const cheadata = jsonData?.data[0]; // Adjust index based on API response
      if (cheadata) {
        setCostingHead({
          L: cheadata.attributes?.L || 0,
          M: cheadata.attributes?.M || 0,
          X: cheadata.attributes?.X || 0
        });
      }
    } catch (error) {
      console.error('Error fetching costing heads:', error);
    }
  };
  const [updatedRows, setUpdatedRows] = useState({});

  const handleBasePriceChange = (value, rowData) => {
    const basePrice = parseFloat(value);
    const safeBasePrice = isNaN(basePrice) ? 0 : basePrice;
    const updatedRow = {
      ...rowData,
      SellingPrice: safeBasePrice,
      L: (safeBasePrice + (safeBasePrice * costinghead.L) / 100).toFixed(2),
      M: (safeBasePrice + (safeBasePrice * costinghead.M) / 100).toFixed(2),
      MX: (safeBasePrice + (safeBasePrice * costinghead.X) / 100).toFixed(2),
      SellingPriceCurrency:
        updatedRows[rowData.id]?.SellingPriceCurrency ?? rowData.attributes.SellingPriceCurrency
    };

    setUpdatedRows(prev => ({
      ...prev,
      [rowData.id]: updatedRow
    }));
  };

  const [currencyList, setCurrencyList] = useState([]);

  useEffect(() => {
    const fetchCurrencies = async () => {
      const res = await fetch(`${globalIP}/api/currency-masters`);
      const data = await res.json();
      const currencies = data.data.map(item => item.attributes.currencyname);
      setCurrencyList(currencies);
    };

    fetchCurrencies();
  }, []);

  const defaultColumns = [
    {
      key: 'Image',
      label: 'Image',
      fixed: true,
      width: 100,
      headerCell: (
        <Table.HeaderCell flexGrow={1}>
          <b>Image</b>
        </Table.HeaderCell>
      ),
      cell: (
        <Table.Cell>
          {rowData => {
            // Define a function to show the enlarged image on hover
            const renderTooltip = imageSrc => (
              <Tooltip style={{ backgroundColor: 'white' }} className="prdt-img">
                <img
                  src={imageSrc}
                  alt="Product Image"
                  style={{ width: 400, height: 400, objectFit: 'contain' }}
                />
              </Tooltip>
            );

            return (
              <Whisper
                trigger="hover"
                placement="right"
                speaker={renderTooltip(
                  `${globalIP}${rowData.attributes?.CoverImage?.data?.attributes?.url}`
                )}
              >
                <img
                  src={`${globalIP}${rowData.attributes?.CoverImage?.data?.attributes?.url}`}
                  alt="Product Image"
                  style={{ width: 50, height: 50, marginTop: '-16px', objectFit: 'contain' }}
                />
              </Whisper>
            );
          }}
        </Table.Cell>
      )
    },
    {
      key: 'ProductId',
      label: `${label[0]?.attributes.AliasCode}`,
      width: 100,
      headerCell: (
        <Table.HeaderCell flexGrow={1}>
          <b>{label[0]?.attributes.AliasCode}</b>
        </Table.HeaderCell>
      ),
      cell: <Cell>{rowData => rowData.attributes.ProductId}</Cell>
    },
    {
      key: 'ProductName',
      label: `${label[0]?.attributes.ProductName}`,
      width: 250,
      headerCell: (
        <Table.HeaderCell flexGrow={1}>
          <b>{label[0]?.attributes.ProductName}</b>
        </Table.HeaderCell>
      ),
      cell: <Cell>{rowData => rowData.attributes.ProductName}</Cell>
    },
    {
      key: 'CategoryName',
      label: `${label[0]?.attributes.Category}`,
      width: 180,
      headerCell: (
        <Table.HeaderCell flexGrow={1}>
          <b>{label[0]?.attributes.Category}</b>
        </Table.HeaderCell>
      ),
      cell: <Cell>{rowData => rowData.attributes.CategoryName}</Cell>
    },
    {
      key: 'ProductTypeName',
      label: `${label[0]?.attributes.ProductType}`,
      width: 180,
      headerCell: (
        <Table.HeaderCell flexGrow={1}>
          <b>{label[0]?.attributes.ProductType}</b>
        </Table.HeaderCell>
      ),
      cell: <Cell>{rowData => rowData.attributes.ProductTypeName}</Cell>
    },
    {
      key: 'SizeUnit',
      label: `${label[0]?.attributes.Sizeunit}`,
      width: 100,
      headerCell: (
        <Table.HeaderCell flexGrow={1}>
          <b>{label[0]?.attributes.Sizeunit}</b>
        </Table.HeaderCell>
      ),
      cell: (
        <Cell>
          {rowData =>
            `${rowData.attributes.Length}x${rowData.attributes.Width}x${rowData.attributes.Height} ${rowData.attributes.SizeUnit}`
          }
        </Cell>
      )
    },
    {
      key: 'Currency',
      label: <b>Currency</b>,
      width: 100,
      cell: (
        <Cell>
          {rowData => (
            <SelectPicker
              data={currencyList.map(currency => ({ label: currency, value: currency }))}
              value={
                updatedRows[rowData.id]?.SellingPriceCurrency ||
                rowData.attributes.SellingPriceCurrency ||
                'USD'
              }
              onChange={newCurrency => {
                setUpdatedRows(prev => ({
                  ...prev,
                  [rowData.id]: {
                    ...(prev[rowData.id] || rowData),
                    SellingPriceCurrency: newCurrency
                  }
                }));
              }}
              style={{ width: '100%' }}
              cleanable={false}
              searchable={true}
              placement="autoVertical"
            />
          )}
        </Cell>
      )
    },
    {
      key: 'BasePrice',
      label: <b>Base Price</b>,
      width: 100,
      cell: (
        <Cell>
          {rowData => (
            <Input
              type="number"
              step="any"
              value={updatedRows[rowData.id]?.SellingPrice ?? rowData.attributes.SellingPrice}
              onChange={value => handleBasePriceChange(value, rowData)}
            />
          )}
        </Cell>
      )
    },
    {
      key: 'L',
      label: <b>L</b>,
      width: 100,
      cell: (
        <Cell>
          {rowData => <Input value={updatedRows[rowData.id]?.L ?? rowData.attributes.L} readOnly />}
        </Cell>
      )
    },
    {
      key: 'M',
      label: <b>M</b>,
      width: 100,
      cell: (
        <Cell>
          {rowData => <Input value={updatedRows[rowData.id]?.M ?? rowData.attributes.M} readOnly />}
        </Cell>
      )
    },
    {
      key: 'MX',
      label: <b>MX</b>,
      width: 100,
      cell: (
        <Cell>
          {rowData => (
            <Input value={updatedRows[rowData.id]?.MX ?? rowData.attributes.MX} readOnly />
          )}
        </Cell>
      )
    },
    {
      key: 'UpdatedDate',
      label: <b>Last Updated Date</b>,
      width: 160,
      cell: (
        <Cell>
          {rowData => {
            const updatedAt = rowData.attributes.updatedAt;
            const formattedDate = updatedAt
              ? new Date(updatedAt).toLocaleString('en-IN', {
                dateStyle: 'medium',
                timeStyle: 'short'
              })
              : 'N/A';
            return formattedDate;
          }}
        </Cell>
      )
    }
  ];
  const [status, setStatus] = useState('Regular');
  const [status1, setStatus1] = useState('');
  const saveAllChanges = async () => {
    let updates = Object.values(updatedRows);

    // If Buyer is selected and no changes detected, save all tableData rows
    if (status !== 'Regular' && updates.length === 0) {
      updates = tableData; // Save all rows for buyer
    }

    if (updates.length === 0) {
      alert('No changes to save.');
      return;
    }

    try {
      if (status === 'Regular') {
        // const currencyRes = await fetch(
        //   `${globalIP}/api/currency-masters?populate=*&filters[currencyname][$eq]=USD`
        // );
        // const currencyData = await currencyRes.json();
        // const usdCurrency = currencyData.data[0];
        // if (!usdCurrency) {
        //   alert('USD currency not found in currency-masters API.');
        //   return;
        // }
        // const exchangename = usdCurrency.attributes.currencyname;
        // const exchangeRate = usdCurrency.attributes.exchangerate;

        // Save only updated rows for products
        await Promise.all(
          updates
            .filter(row => row.SellingPrice !== undefined || row.SellingPriceCurrency !== undefined)
            // .filter(row => row.SellingPrice !== undefined && row.SellingPrice !== null)
            .map(async row => {
              const currencyRes = await fetch(
                `${globalIP}/api/currency-masters?populate=*&filters[currencyname][$eq]=${row.SellingPriceCurrency || 'USD'
                }`
              );
              const currencyData = await currencyRes.json();
              const usdCurrency = currencyData.data[0];
              if (!usdCurrency) {
                alert(`Currency ${row.SellingPriceCurrency} not found.`);
                return;
              }
              const exchangename = usdCurrency.attributes.currencyname;
              const exchangeRate = usdCurrency.attributes.exchangerate;
              return fetch(`${globalIP}/api/products/${row.id}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                  data: {
                    SellingPrice: row.SellingPrice,
                    L: row.L,
                    M: row.M,
                    MX: row.MX,
                    SellingPriceCurrency: exchangename,
                    SellingPriceUnit: String(exchangeRate),
                    ProductCost: row.SellingPrice * exchangeRate
                  }
                })
              });
            })
        );
      } else {
        if (!status1) {
          toaster.push(
            <Message showIcon type="error">
              Please select a Buyer before saving.
            </Message>,
            { placement: 'topCenter' }
          );
          return;
        }
        // Fetch existing price-listings for matching
        const res = await fetch(`${globalIP}/api/price-listings?populate=*`);
        const existingData = await res.json();
        const priceList = existingData.data;

        await Promise.all(
          updates
            .filter(row => row.SellingPrice !== undefined || row.SellingPriceCurrency !== undefined)
            // .filter(row => row.SellingPrice != 0)
            .map(async row => {
              const matched = priceList.find(
                item =>
                  item.attributes.ProductCode === row.attributes.ProductCode &&
                  item.attributes.BuyerName === status1
              );

              const payload = {
                data: {
                  ProductCode: row.attributes.ProductCode,
                  SellingPrice: row.SellingPrice,
                  L: row.L,
                  M: row.M,
                  MX: row.MX,
                  BuyerName: status1,
                  SellingPriceCurrency: row.SellingPriceCurrency
                }
              };

              if (matched) {
                // Update existing entry
                return fetch(`${globalIP}/api/price-listings/${matched.id}`, {
                  method: 'PUT',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify(payload)
                });
              } else {
                // Create new entry
                return fetch(`${globalIP}/api/price-listings`, {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify(payload)
                });
              }
            })
        );
      }

      alert('Changes saved successfully!');
      setUpdatedRows({});
      TableFetchData();
    } catch (error) {
      console.error('Error saving changes:', error);
      alert('Failed to save changes.');
    }
  };

  const [isLoading, setIsLoading] = useState(false);
  const [noData, setNoData] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [tableMeta, setTableMeta] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState([]);
  const [selectedProductType, setSelectedProductType] = useState([]);
  const [selectedColor, setSelectedColor] = useState([]);
  const [selectedFinish, setSelectedFinish] = useState([]);
  const [selectedhsn, setSelectedhsn] = useState([]);
  const [selectedmaterial, setSelectedmaterial] = useState([]);
  const [selectedBuyer, setSelectedBuyer] = useState([]);
  const [selectedSearch, setSelectedSearch] = useState([]);
  const [selectedAlias, setSelectedAlias] = useState([]);
  const [selectedpron, setSelectedPron] = useState([]);
  const [selectedpd, setSelectedProd] = useState([]);
  const [selectedmade, setSelectedMade] = useState([]);
  const [selectedsku, setSelectedSku] = useState([]);
  const [authst, setAuthst] = useState('Authorised');
  const [searchQuery, setSearchQuery] = useState('');

  const [showDrawer, setShowDrawer] = useState(false);

  const [isLoadingTableData, SetIsLoadingTableData] = useState(false);
  const [progress, setProgress] = useState(0);
  const [page, setPage] = useState(1);
  const [reload, setReload] = useState(false);
  const [clearSearchQuery, setClearSearchQuery] = useState(false);

  const [selectedDateRange, setSelectedDateRange] = useState(null);
  const [selectedUpdatedDateRange, setSelectedUpdatedDateRange] = useState(null);
  const handleDatechange = value => {
    setSelectedDateRange(value);
  };
  const handleUpdatedDatechange = value => {
    setSelectedUpdatedDateRange(value);
  };
  const formatDateToISO = date => date.toISOString();

  const getFirstDayOfWeek = date => {
    const firstDay = new Date(date);
    firstDay.setDate(date.getDate() - firstDay.getDay()); // Sunday is the first day of the week
    firstDay.setHours(0, 0, 0, 0);
    return formatDateToISO(firstDay);
  };

  const getFirstDayOfMonth = date => {
    const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    firstDay.setHours(0, 0, 0, 0);
    return formatDateToISO(firstDay);
  };

  const getFirstDayOfLastMonth = date => {
    const firstDayOfLastMonth = new Date(date.getFullYear(), date.getMonth() - 1, 1);
    firstDayOfLastMonth.setHours(0, 0, 0, 0);
    return formatDateToISO(firstDayOfLastMonth);
  };

  const getLastDayOfLastMonth = date => {
    const lastDayOfLastMonth = new Date(date.getFullYear(), date.getMonth(), 0);
    lastDayOfLastMonth.setHours(23, 59, 59, 999);
    return formatDateToISO(lastDayOfLastMonth);
  };

  const getDateDaysAgo = (date, days) => {
    const result = new Date(date);
    result.setDate(date.getDate() - days);
    result.setHours(0, 0, 0, 0);
    return formatDateToISO(result);
  };
  useEffect(() => {
    TableFetchData();
  }, [page, reload]);
  const [checkbox, setCheckbox] = useState(false);
  useEffect(() => {
    setPage(1);
    TableFetchData();
  }, [
    selectedUpdatedDateRange,
    selectedDateRange,
    selectedCategory,
    selectedProductType,
    selectedColor,
    selectedFinish,
    selectedhsn,
    selectedmaterial,
    selectedBuyer,
    selectedSearch,
    selectedAlias,
    selectedpron,
    selectedpd,
    selectedmade,
    selectedsku,
    authst,
    status1,
    status,
    checkbox
  ]);
  const TableFetchData = async () => {
    if (isLoading) {
      return;
    }
    setIsLoading(true);

    let categoryFilter = '';
    if (selectedCategory.length > 0) {
      const categoryFilterString = selectedCategory
        .map(cat => `filters[CategoryCode][$eq]=${cat}`)
        .join('&');
      categoryFilter = `&${categoryFilterString}`;
    }
    let protypeFilter = '';
    if (selectedProductType.length > 0) {
      const protypeFilterString = selectedProductType
        .map(pro => `filters[ProductTypeCode][$eq]=${pro}`)
        .join('&');
      protypeFilter = `&${protypeFilterString}`;
    }
    let colorFilter = '';
    if (selectedColor.length > 0) {
      const colorFilterString = selectedColor
        .map(
          color =>
            `filters[$or][0][ColorCode][$eq]=${color}&filters[$or][1][SetSizes][ColorCode][$eq]=${color}`
        )
        .join('&');
      colorFilter = `&${colorFilterString}`;
    }
    let finishFilter = '';
    if (selectedFinish.length > 0) {
      const finishFilterString = selectedFinish
        .map(finish => `filters[FinishCode][$eq]=${finish}`)
        .join('&');
      finishFilter = `&${finishFilterString}`;
    }
    let hsnFilter = '';
    if (selectedhsn.length > 0) {
      const hsnFilterString = selectedhsn.map(hsn => `filters[HSNCode][$eq]=${hsn}`).join('&');
      hsnFilter = `&${hsnFilterString}`;
    }
    let matFilter = '';
    if (selectedmaterial.length > 0) {
      const matFilterString = selectedmaterial
        .map(mat => `filters[ProductionDetail][MaterialCode][$eq]=${mat}`)
        .join('&');
      matFilter = `&${matFilterString}`;
    }
    let buyerFilter = '';
    if (selectedBuyer.length > 0) {
      const buyerFilterString = selectedBuyer
        .map(buyer => `filters[BuyerName][$eq]=${buyer}`)
        .join('&');
      buyerFilter = `&${buyerFilterString}`;
    }
    let searchFilter = '';
    if (selectedSearch.length > 0) {
      const SearchFilterString = selectedSearch
        .map(search => `filters[SearchKeyword][$eq]=${search}`)
        .join('&');
      searchFilter = `&${SearchFilterString}`;
    }
    let aliasFilter = '';
    if (selectedAlias.length > 0) {
      const aliasFilterString = selectedAlias
        .map(alias => `filters[ProductId][$eq]=${alias}`)
        .join('&');
      aliasFilter = `&${aliasFilterString}`;
    }
    let pronFilter = '';
    if (selectedpron.length > 0) {
      const pronFilterString = selectedpron
        .map(pron => `filters[ProductName][$eq]=${pron}`)
        .join('&');
      pronFilter = `&${pronFilterString}`;
    }
    let prodFilter = '';
    if (selectedpd.length > 0) {
      const prodFilterString = selectedpd
        .map(prod => `filters[ProductDesigner][$eq]=${prod}`)
        .join('&');
      prodFilter = `&${prodFilterString}`;
    }
    let madeFilter = '';
    if (selectedmade.length > 0) {
      const madeFilterString = selectedmade.map(made => `filters[MadeBy][$eq]=${made}`).join('&');
      madeFilter = `&${madeFilterString}`;
    }
    let skuFilter = '';
    if (selectedsku.length > 0) {
      const skuFilterString = selectedsku.map(sku => `filters[BuyerSku][$eq]=${sku}`).join('&');
      skuFilter = `&${skuFilterString}`;
    }
    let authFilter = '';
    if (authst.length > 0) {
      authFilter = `&filters[Authorized][$eq]=${authst}`;
    }
    let searchQryFilter = '';
    if (searchQuery.length > 0) {
      let searchQryy = searchQuery.trim();
      const searchQry1 = `filters[$or][0][ProductId][$containsi]=${searchQryy}&filters[$or][1][ProductName][$containsi]=${searchQryy}&filters[$or][2][SearchKeyword][$containsi]=${searchQryy}&filters[$or][3][SellingPrice][$containsi]=${searchQryy}&filters[$or][4][L][$containsi]=${searchQryy}&filters[$or][5][M][$containsi]=${searchQryy}&filters[$or][6][MX][$containsi]=${searchQryy}`;
      const searchQry2 = `filters[$or][0][SellingPrice][$containsi]=${searchQryy}&filters[$or][1][L][$containsi]=${searchQryy}&filters[$or][2][M][$containsi]=${searchQryy}&filters[$or][3][MX][$containsi]=${searchQryy}`;
      searchQryFilter = status == 'Regular' ? `&${searchQry1}` : `&${searchQry2}`;
    }
    let buyerCodeFilter = '';
    if (status !== 'Regular' && status1) {
      buyerCodeFilter = `&filters[BuyerName][$eq]=${status1}`;
    }
    let datefilter = '';
    let updateddatefilter = '';

    const today = new Date();
    const startOfToday = new Date(today.setHours(0, 0, 0, 0)); // Set time to 00:00:00
    const endOfToday = new Date(); // Current time

    switch (selectedDateRange) {
      case 'Today':
        datefilter = `filters[createdAt][$gte]=${formatDateToISO(
          startOfToday
        )}&filters[createdAt][$lte]=${formatDateToISO(endOfToday)}`;
        break;

      case 'Yesterday':
        const yesterday = new Date();
        yesterday.setDate(today.getDate() - 1);
        datefilter = `filters[createdAt][$eq]=${formatDateToISO(yesterday)}`;
        break;

      case 'This week':
        datefilter = `filters[createdAt][$gte]=${getFirstDayOfWeek(today)}`;
        break;

      case 'Last week':
        const lastWeekStart = new Date(today);
        lastWeekStart.setDate(today.getDate() - today.getDay() - 7); // Start of last week
        datefilter = `filters[createdAt][$gte]=${formatDateToISO(
          lastWeekStart
        )}&filters[createdAt][$lte]=${getFirstDayOfWeek(today)}`;
        break;

      case 'This month':
        datefilter = `filters[createdAt][$gte]=${getFirstDayOfMonth(today)}`;
        break;

      case 'Last month':
        datefilter = `filters[createdAt][$gte]=${getFirstDayOfLastMonth(
          today
        )}&filters[createdAt][$lte]=${getLastDayOfLastMonth(today)}`;
        break;

      case 'Last 3 month':
        const threeMonthsAgo = new Date(today);
        threeMonthsAgo.setMonth(today.getMonth() - 3);
        datefilter = `filters[createdAt][$gte]=${formatDateToISO(threeMonthsAgo)}`;
        break;

      case 'Last 6 month':
        const sixMonthsAgo = new Date(today);
        sixMonthsAgo.setMonth(today.getMonth() - 6);
        datefilter = `filters[createdAt][$gte]=${formatDateToISO(sixMonthsAgo)}`;
        break;

      default: // Or handle the default case as needed
        datefilter = '';
        break;
    }

    switch (selectedUpdatedDateRange) {
      case 'Today':
        updateddatefilter = `&filters[updatedAt][$gte]=${formatDateToISO(
          startOfToday
        )}&filters[updatedAt][$lte]=${formatDateToISO(endOfToday)}`;
        break;

      case 'Yesterday':
        updateddatefilter = `&filters[updatedAt][$eq]=${getDateDaysAgo(today, 1)}`;
        break;

      case 'This week':
        updateddatefilter = `&filters[updatedAt][$gte]=${getFirstDayOfWeek(today)}`;
        break;

      case 'Last week':
        const lastWeekStart = new Date(today);
        lastWeekStart.setDate(today.getDate() - today.getDay() - 7); // Start of last week
        updateddatefilter = `&filters[updatedAt][$gte]=${formatDateToISO(
          lastWeekStart
        )}&filters[updatedAt][$lte]=${getFirstDayOfWeek(today)}`;
        break;

      case 'This month':
        updateddatefilter = `&filters[updatedAt][$gte]=${getFirstDayOfMonth(today)}`;
        break;

      case 'Last month':
        updateddatefilter = `&filters[updatedAt][$gte]=${getFirstDayOfLastMonth(
          today
        )}&filters[updatedAt][$lte]=${getLastDayOfLastMonth(today)}`;
        break;

      case 'Last 3 month':
        const threeMonthsAgo = new Date(today);
        threeMonthsAgo.setMonth(today.getMonth() - 3);
        updateddatefilter = `&filters[updatedAt][$gte]=${formatDateToISO(threeMonthsAgo)}`;
        break;

      case 'Last 6 month':
        const sixMonthsAgo = new Date(today);
        sixMonthsAgo.setMonth(today.getMonth() - 6);
        updateddatefilter = `&filters[updatedAt][$gte]=${formatDateToISO(sixMonthsAgo)}`;
        break;

      default: // Or handle the default case as needed
        updateddatefilter = '';
        break;
    }


    let check = '';
    if (checkbox == false) {
      check = '&filters[$or][0][L][$ne]=0&filters[$or][1][M][$ne]=0&filters[$or][2][MX][$ne]=0';
    }
    const response = await fetch(
      `${globalIP}/api/products?populate=*&sort[0]=id:desc&pagination[page]=${page}${check}${categoryFilter}${protypeFilter}${colorFilter}${finishFilter}${hsnFilter}${matFilter}${buyerFilter}${searchFilter}${aliasFilter}${pronFilter}${prodFilter}${madeFilter}${skuFilter}${authFilter}${buyerCodeFilter}${searchQryFilter}&${updateddatefilter}&${datefilter}`
    );


    const json = await response.json();
    const products = json.data;
    // if (status !== 'Regular') {
    //   const buyerPricesRes = await fetch(
    //     `${globalIP}/api/price-listings?populate=*&${status != 'Regular' ? searchQryFilter : ''}`
    //   );
    //   const buyerPricesJson = await buyerPricesRes.json();
    //   const priceData = buyerPricesJson.data;

    //   // Attach buyer L,M,MX to each product if matched by ProductCode and BuyerName
    //   const updatedProducts = products.map(product => {
    //     const productCode = product.attributes.ProductCode;
    //     const matched = priceData.find(
    //       price =>
    //         price.attributes.ProductCode === productCode && price.attributes.BuyerName === status1 // status holds BuyerName now
    //     );
    //     return {
    //       ...product,
    //       attributes: {
    //         ...product.attributes,
    //         L: matched?.attributes.L ?? 0,
    //         M: matched?.attributes.M ?? 0,
    //         MX: matched?.attributes.MX ?? 0,
    //         SellingPrice: matched?.attributes.SellingPrice ?? 0,
    //         SellingPriceCurrency: matched?.attributes.SellingPriceCurrency ?? '',
    //         updatedAt: matched?.attributes.updatedAt ?? product.attributes.updatedAt
    //       }
    //     };
    //   });
    //   if (searchQryFilter) {
    //     console.log('updatedProducts before filter', updatedProducts);
    //     const filteredProducts = updatedProducts.filter(product => {
    //       const matchesSearchQuery =
    //         product.attributes.L == searchQuery ||
    //         product.attributes.M == searchQuery ||
    //         product.attributes.MX == searchQuery ||
    //         product.attributes.SellingPrice == searchQuery;

    //       console.log('product matches searchQuery:', matchesSearchQuery);
    //       return matchesSearchQuery;
    //     });

    //     console.log('filteredProducts after filter', filteredProducts);
    //     // If you want to update the updatedProducts array with the filtered results
    //     updatedProducts.length = 0; // Clear the original array
    //     updatedProducts.push(...filteredProducts); // Add the filtered items
    //     // setTableMeta(buyerPricesJson.meta);
    //   }
    //   let finalProducts = updatedProducts;
    //   if (checkbox === false) {
    //     // Only include products with at least one of L, M, or MX not equal to 0
    //     finalProducts = updatedProducts.filter(product => {
    //       const { L, M, MX } = product.attributes;
    //       return L || M || MX;
    //     });
    //   }

    //   setTableData(finalProducts);
    //   setTableMeta({ pagination: { total: checkbox ? json.meta.pagination.total : finalProducts.length } });
    // } else {
    let finalallProduct = products;
    // if (checkbox === false) {
    //   // Only include products with at least one of L, M, or MX not equal to 0
    //   finalallProduct = products.filter(product => {
    //     const { L, M, MX } = product.attributes;
    //     return L || M || MX;
    //   });
    // }
    // Regular: show from original product API
    setTableData(finalallProduct);
    setTableMeta({
      pagination: {
        total: checkbox ? json.meta.pagination.total : finalallProduct.length
      }
    });
    // }

    setIsLoading(false);
  };
  useEffect(() => {
    if (checkbox == false) {
      setPage(1);
    }
  }, [checkbox]);

  const handleChangeLimit = () => {
    setPage(1);
  };

  const [shouldRecalculate, setShouldRecalculate] = useState(false);

  useEffect(() => {
    if (!shouldRecalculate) return;
    const autoUpdatedRows = {};
    tableData.forEach(row => {
      handleBasePriceChange(row.attributes?.SellingPrice, row); // only if needed
      const basePrice = parseFloat(row.SellingPrice || row.attributes?.SellingPrice || 0);
      const Price = row.SellingPriceCurrency || row.attributes?.SellingPriceCurrency || '';
      if (basePrice > 0) {
        autoUpdatedRows[row.id] = {
          ...row,
          SellingPrice: basePrice,
          L: basePrice + (basePrice * costinghead.L) / 100,
          M: basePrice + (basePrice * costinghead.M) / 100,
          MX: basePrice + (basePrice * costinghead.X) / 100,
          SellingPriceCurrency: Price
        };
      }
    });
    setUpdatedRows(autoUpdatedRows);
    setShouldRecalculate(false);
  }, [shouldRecalculate, tableData, costinghead]);

  // useEffect(() => {
  //   // console.log('tableData', tableData);
  //   tableData.forEach((rowData, index) => {
  //     handleBasePriceChange(rowData.attributes.SellingPrice, rowData)
  //   });

  // }, [tableData]);

  const [tableHeight, setTableHeight] = useState(20); // Default height
  useEffect(() => {
    const calculateHeight = () => {
      const headerHeight = 290;
      const footerHeight = 5;
      const availableHeight = window.innerHeight - headerHeight - footerHeight;
      setTableHeight(availableHeight);
    };
    calculateHeight();
    window.addEventListener('resize', calculateHeight);
    return () => window.removeEventListener('resize', calculateHeight);
  }, []);
  const CompactCell = props => <Cell {...props} style={{ padding: 4 }} />;
  const CompactHeaderCell = props => <HeaderCell {...props} style={{ padding: 4 }} />;
  const [compact, setCompact] = useState(true);
  const CustomCell = compact ? CompactCell : Cell;
  const CustomHeaderCell = compact ? CompactHeaderCell : HeaderCell;
  const [columnKeys, setColumnKeys] = React.useState(defaultColumns.map(column => column.key));

  const [selectedCategoryCode, setSelectedCategoryCode] = useState([]);
  const [categorydata, setCategorydata] = useState([]);
  const [isLoadingc, setIsLoadingc] = useState(false);
  useEffect(() => {
    fetchCategory(setCategorydata, isLoadingc, setIsLoadingc, SetIsLoadingTableData, setProgress);
  }, []);

  const [colordata, setColordata] = React.useState([]);
  const [isLoadingcolor, setIsLoadingcolor] = React.useState(false);
  useEffect(() => {
    console.log('colordata', colordata);
  }, [colordata]);
  useEffect(() => {
    fetchColors(setColordata, isLoadingcolor, setIsLoadingcolor);
  }, []);

  const [productypedata, setProductypedata] = useState([]);
  const [isLoadingpro, setIsLoadingpro] = useState(false);
  useEffect(() => {
    if (selectedCategoryCode) {
      fetchProductTypes(setProductypedata, isLoadingpro, selectedCategoryCode, setIsLoadingpro);
    }
  }, [selectedCategoryCode]);

  const [finishdata, setFinishdata] = useState([]);
  const [isLoadingfin, setIsLoadingfin] = useState(false);
  useEffect(() => {
    fetchFinishes(setFinishdata, isLoadingfin, setIsLoadingfin);
  }, []);

  const [materialdata, setMaterialdata] = React.useState([]);
  const [isLoadingmat, setIsLoadingmat] = React.useState(false);
  useEffect(() => {
    fetchMaterials(setMaterialdata, isLoadingmat, setIsLoadingmat);
  }, []);

  const [hsndata, setHsndata] = React.useState([]);
  const [isLoadinghsn, setIsLoadinghsn] = React.useState(false);
  useEffect(() => {
    fetchHsn(setHsndata, isLoadinghsn, setIsLoadinghsn);
  }, []);

  const [buyernamedata, setBuyerNamedata] = useState([]);
  const [isLoadingbu, setIsLoadingbu] = useState(false);
  useEffect(() => {
    fetchBuyers(setBuyerNamedata, isLoadingbu, setIsLoadingbu);
  }, []);

  const [searchdata, setSearchdata] = useState([]);
  const [isLoadingse, setIsLoadingse] = useState(false);
  useEffect(() => {
    fetchSearchKeyword(setSearchdata, isLoadingse, setIsLoadingse);
  }, []);

  const [proNamedata, setProdNamedata] = useState([]);
  const [isLoadingpron, setIsLoadingpron] = useState(false);
  useEffect(() => {
    fetchProductName(setProdNamedata, isLoadingpron, setIsLoadingpron);
  }, []);

  const [proDdata, setProdDdata] = useState([]);
  const [isLoadingprod, setIsLoadingprod] = useState(false);
  useEffect(() => {
    fetchProductDesign(setProdDdata, isLoadingprod, setIsLoadingprod);
  }, []);

  const [madedata, setMadedata] = useState([]);
  const [isLoadingmade, setIsLoadingmade] = useState(false);
  useEffect(() => {
    fetchMadeBy(setMadedata, isLoadingmade, setIsLoadingmade);
  }, []);

  const [skudata, setSkudata] = useState([]);
  const [isLoadingsku, setIsLoadinsku] = useState(false);
  useEffect(() => {
    fetchSkuUnique(setSkudata, isLoadingsku, setIsLoadinsku);
  }, []);
  const [aliasdata, setAliasdata] = useState([]);
  const [isLoadingalias, setIsLoadingalias] = useState(false);
  useEffect(() => {
    fetchAlias(setAliasdata, isLoadingalias, setIsLoadingalias);
  }, []);

  // useEffect for clearing searchQuery
  useEffect(() => {
    if (clearSearchQuery) {
      TableFetchData();
    }
  }, [clearSearchQuery]);

  const [debouncedSearchQuery, setDebouncedSearchQuery] = useState(searchQuery);
  // Debounce effect for searchQuery
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchQuery(searchQuery);
    }, 500); // Adjust the debounce delay as needed

    return () => clearTimeout(timer); // Cleanup the timeout if searchQuery changes before the delay
  }, [searchQuery]);

  // Effect that triggers on debouncedSearchQuery
  useEffect(() => {
    // console.log('searchQuery', debouncedSearchQuery);
    setPage(1);
    TableFetchData(); // Another data fetching function
  }, [debouncedSearchQuery]); // This effect now triggers when debouncedSearchQuery changes
  const handleFilterChange = (
    filterType,
    value,
    prevValue,
    clearSearchQuery,
    setClearSearchQuery
  ) => {
    const tempsearchq = searchQuery;
    setSearchQuery(''); // Clear the search query first

    const anyOtherFilterSelected =
      selectedCategory.length > 0 ||
      selectedProductType.length > 0 ||
      selectedColor.length > 0 ||
      selectedFinish.length > 0 ||
      selectedhsn.length > 0 ||
      selectedmaterial.length > 0 ||
      selectedBuyer.length > 0 ||
      selectedSearch.length > 0 ||
      selectedAlias.length > 0 ||
      selectedpron.length > 0 ||
      selectedpd.length > 0 ||
      selectedmade.length > 0 ||
      selectedsku.length > 0;

    // Handle setting clearSearchQuery flag
    if (anyOtherFilterSelected || prevValue.length === 0) {
      setClearSearchQuery(true);
    } else {
      setClearSearchQuery(false);
      setSearchQuery(tempsearchq);
    }

    // Set the filter state for the specific filter type
    switch (filterType) {
      case 'category':
        setSelectedCategory(value);
        break;
      case 'productType':
        setSelectedProductType(value);
        break;
      case 'color':
        setSelectedColor(value);
        break;
      case 'finish':
        setSelectedFinish(value);
        break;
      case 'hsn':
        setSelectedhsn(value);
        break;
      case 'material':
        setSelectedmaterial(value);
        break;
      case 'buyer':
        setSelectedBuyer(value);
        break;
      case 'search':
        setSelectedSearch(value);
        break;
      case 'alias':
        setSelectedAlias(value);
        break;
      case 'productName':
        setSelectedPron(value);
        break;
      case 'productDescription':
        setSelectedProd(value);
        break;
      case 'made':
        setSelectedMade(value);
        break;
      case 'sku':
        setSelectedSku(value);
        break;
      default:
        break;
    }

    // Reset pagination
    setPage(1);
    setReload(prev => !prev);
  };

  const handleCategoryChange = value => {
    handleFilterChange('category', value, selectedCategory, clearSearchQuery, setClearSearchQuery);
  };
  const handleProductTypeChange = value => {
    handleFilterChange(
      'productType',
      value,
      selectedProductType,
      clearSearchQuery,
      setClearSearchQuery
    );
  };
  const handleColorChange = value => {
    handleFilterChange('color', value, selectedColor, clearSearchQuery, setClearSearchQuery);
  };
  const handleFinishChange = value => {
    handleFilterChange('finish', value, selectedFinish, clearSearchQuery, setClearSearchQuery);
  };
  const handleHSNChange = value => {
    handleFilterChange('hsn', value, selectedhsn, clearSearchQuery, setClearSearchQuery);
  };
  const handleMaterialChange = value => {
    handleFilterChange('material', value, selectedmaterial, clearSearchQuery, setClearSearchQuery);
  };
  const handleBuyerChange = value => {
    handleFilterChange('buyer', value, selectedBuyer, clearSearchQuery, setClearSearchQuery);
  };
  const handleSearchChange = value => {
    handleFilterChange('search', value, selectedSearch, clearSearchQuery, setClearSearchQuery);
  };
  const handleAliasChange = value => {
    handleFilterChange('alias', value, selectedAlias, clearSearchQuery, setClearSearchQuery);
  };
  const handleProNameChange = value => {
    handleFilterChange('productName', value, selectedpron, clearSearchQuery, setClearSearchQuery);
  };
  const handleProDChange = value => {
    handleFilterChange(
      'productDescription',
      value,
      selectedpd,
      clearSearchQuery,
      setClearSearchQuery
    );
  };
  const handleMadeChange = value => {
    handleFilterChange('made', value, selectedmade, clearSearchQuery, setClearSearchQuery);
  };
  const handleSkuChange = value => {
    handleFilterChange('sku', value, selectedsku, clearSearchQuery, setClearSearchQuery);
  };

  const FixedLoader = () => (
    <Loader
      content="Loading..."
      style={{
        display: 'flex',
        justifyContent: 'center',
        position: 'absolute',
        bottom: '0',
        background: '#fff',
        width: '100%',
        padding: '4px 0'
      }}
    />
  );
  const renderMenu = menu => {
    return (
      <>
        {menu}
        {isLoadingse && <FixedLoader />}
      </>
    );
  };
  const renderMenu1 = menu => {
    return (
      <>
        {menu}
        {isLoadingalias && <FixedLoader />}
      </>
    );
  };
  const renderMenu2 = menu => {
    return (
      <>
        {menu}
        {isLoadingpron && <FixedLoader />}
      </>
    );
  };
  const renderMenu3 = menu => {
    return (
      <>
        {menu}
        {isLoadingprod && <FixedLoader />}
      </>
    );
  };
  const renderMenu4 = menu => {
    return (
      <>
        {menu}
        {isLoadingmade && <FixedLoader />}
      </>
    );
  };
  const renderMenu5 = menu => {
    return (
      <>
        {menu}
        {isLoadingsku && <FixedLoader />}
      </>
    );
  };
  const [openMenuBar, setOpenMenuBar] = useState(false);
  const [head, setHead] = useState([]);
  useEffect(() => {
    fetchHeads(setHead);
  }, []);
  const [buyerdata, setBuyerData] = useState([]);
  useEffect(() => {
    fetchBuyersLocally();
  }, []);
  const fetchBuyersLocally = async () => {
    try {
      const response = await fetch(`${globalIP}/api/buyer-details?&pagination[page]=1`);
      const json = await response.json();
      const allData = [];
      for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
        const pageResponse = await fetch(`${globalIP}/api/buyer-details?&pagination[page]=${page}`);
        const pageJson = await pageResponse.json();
        const processedData = pageJson.data.map(item => ({
          label: item.attributes.buyernm,
          value: item.attributes.buyernm
        }));
        allData.push(...processedData);
      }
      setBuyerData(allData.sort((a, b) => a.label.localeCompare(b.label)));
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };
  return (
    <>
      <Container className="main">
        <div
          style={{
            justifyContent: 'space-between',
            width: '-webkit-fill-available',
            position: 'fixed',
            height: '180px',
            background: '#fff',
            zIndex: 1
          }}
        >
          <Stack className="table-toolbar  selection-head" justifyContent="space-between">
            <Stack direction="column" alignItems="flex-start">
              <Stack direction="column" alignItems="flex-start">
                <Stack direction="row" alignItems="flex-start" spacing={140}>
                  <h3 className="title">Price List</h3>
                </Stack>
                <Breadcrumb>
                  <Breadcrumb.Item>
                    <Link to={`/${ugr}/dashboard`}>Home</Link>
                  </Breadcrumb.Item>
                  <Breadcrumb.Item active>Select Product</Breadcrumb.Item>
                </Breadcrumb>
              </Stack>
              <Stack spacing={5} className={openMenuBar ? 'product-item' : 'mange-search'}>
                <HeaderFilter
                  {...{
                    head,
                    label,
                    //data states
                    categorydata,
                    productypedata,
                    colordata,
                    proNamedata,
                    skudata,
                    buyernamedata,
                    finishdata,
                    aliasdata,
                    searchdata,
                    proDdata,
                    madedata,
                    hsndata,
                    materialdata,
                    setCategorydata,
                    setIsLoadingc,
                    isLoadingc,
                    SetIsLoadingTableData,
                    setProgress,
                    setColordata,
                    isLoadingcolor,
                    setIsLoadingcolor,
                    // setFinishdata,
                    isLoadingfin,
                    setIsLoadingfin,
                    setHsndata,
                    isLoadinghsn,
                    setIsLoadinghsn,
                    //selectedstates
                    selectedCategory,
                    selectedProductType,
                    selectedColor,
                    selectedpron,
                    selectedsku,
                    selectedBuyer,
                    selectedFinish,
                    selectedAlias,
                    selectedSearch,
                    selectedpd,
                    selectedmade,
                    selectedhsn,
                    selectedmaterial,
                    //onchangehandlers
                    selectedDateRange,
                    handleDatechange,
                    selectedUpdatedDateRange,
                    handleUpdatedDatechange,
                    handleCategoryChange,
                    handleProductTypeChange,
                    handleColorChange,
                    handleProNameChange,
                    handleSkuChange,
                    handleBuyerChange,
                    handleFinishChange,
                    handleAliasChange,
                    handleSearchChange,
                    handleProDChange,
                    handleMadeChange,
                    handleHSNChange,
                    handleMaterialChange,
                    //onopenfunctions
                    fetchCategory,
                    fetchColors,
                    fetchFinishes,
                    fetchProductTypes,
                    fetchAlias,
                    //rendermenus
                    renderMenu2,
                    renderMenu5,
                    renderMenu1,
                    renderMenu,
                    renderMenu3,
                    renderMenu4
                  }}
                />
                {/* <AddedOnFIlter
                  {...{
                    showboth: 'both',
                    AddedOn,
                    selectedDateRange,
                    handleDatechange,
                    selectedUpdatedDateRange,
                    handleUpdatedDatechange
                  }}
                /> */}
                <Button appearance="default" active onClick={() => setShowDrawer(true)}>
                  More Filter
                </Button>
                <SelectPicker
                  data={data}
                  value={status}
                  onChange={setStatus}
                  searchable={false}
                  cleanable={false}
                  style={{ width: 145 }}
                />
                {status == 'Buyer' && (
                  <SelectPicker
                    data={buyerdata}
                    placeholder="Buyer"
                    value={status1}
                    onChange={setStatus1}
                    style={{ width: 145 }}
                  />
                )}
              </Stack>
            </Stack>

            <Stack
              direction="column"
              alignItems="flex-end"
              spacing={17}
              className="mange-search catalogue-search cat "
            >
              <Stack direction="row" spacing={5} className="selection-search">
                <InputGroup inside>
                  <Input
                    placeholder="Search"
                    type="text"
                    value={searchQuery}
                    onChange={value => {
                      setSearchQuery(value);
                    }}
                  />
                  <InputGroup.Addon>
                    <SearchIcon />
                  </InputGroup.Addon>
                </InputGroup>
                <Button appearance="default" active onClick={() => setShouldRecalculate(true)}>
                  Update
                </Button>
                <Button appearance="primary" color="cyan" onClick={saveAllChanges}>
                  Save
                </Button>
                {/* <Button onClick={searchQry}>Search</Button> */}
              </Stack>
              <Stack spacing={10} className="ctlog-slct" style={{ marginTop: '-10px' }}>
                <Checkbox value={checkbox} onChange={() => {
                  setPage(1)
                  setCheckbox(!checkbox)
                }}>
                  All
                </Checkbox>
              </Stack>
            </Stack>
          </Stack>
          <Divider className="divide product-dvd" style={{ marginBottom: '10px' }} />
        </div>
        {/* {console.log("@@@@",tableMeta)} */}
        <div className="cat-row-image" style={{ marginTop: '168px' }}>
          <Panel>
            <Table
              className="cstm-row"
              virtualized
              wordWrap="break-word"
              shouldUpdateScroll={false}
              loading={isLoading}
              rowHeight={60}
              cellBordered
              data={noData ? [] : tableData}
              height={tableHeight}
              rowKey="id"
              style={{ position: 'sticky' }}
              onRowClick={() => { }}
              bordered
            >
              {defaultColumns
                // .filter(column => auth || (column.key !== 'AuthorisedBy' && column.key !== 'AuthDate')) // Hide columns if auth is false
                .map(column => {
                  if (columnKeys.includes(column.key)) {
                    const { key, label, headerCell, cell, ...rest } = column;
                    return (
                      <Table.Column {...rest} key={key} align="center">
                        {headerCell || <CustomHeaderCell>{label}</CustomHeaderCell>}
                        {cell || <CustomCell dataKey={key} />}
                      </Table.Column>
                    );
                  }
                  return null;
                })}
            </Table>

            <div style={{ padding: 20 }}>
              <Pagination
                prev
                next
                first
                last
                ellipsis
                boundaryLinks
                maxButtons={5}
                size="xs"
                layout={['total', '-', 'pager', 'skip']}
                total={tableMeta?.pagination?.total || 0}
                activePage={page}
                onChangePage={setPage}
                onChangeLimit={handleChangeLimit}
              />
            </div>
          </Panel>
        </div>
        <FilterDrawer
          {...{
            showDrawer,
            setShowDrawer,
            head,
            label,
            //data states
            categorydata,
            productypedata,
            colordata,
            proNamedata,
            skudata,
            buyernamedata,
            finishdata,
            aliasdata,
            searchdata,
            proDdata,
            madedata,
            hsndata,
            materialdata,
            setCategorydata,
            setIsLoadingc,
            isLoadingc,
            SetIsLoadingTableData,
            setProgress,
            setColordata,
            isLoadingcolor,
            setIsLoadingcolor,
            setFinishdata,
            isLoadingfin,
            setIsLoadingfin,
            setHsndata,
            isLoadinghsn,
            setIsLoadinghsn,
            setMaterialdata,
            isLoadingmat,
            setIsLoadingmat,
            //selectedstates
            selectedCategory,
            selectedProductType,
            selectedColor,
            selectedpron,
            selectedsku,
            selectedBuyer,
            selectedFinish,
            selectedAlias,
            selectedSearch,
            selectedpd,
            selectedmade,
            selectedhsn,
            selectedmaterial,
            selectedDateRange,
            selectedUpdatedDateRange,

            //onchangehandlers
            handleCategoryChange,
            handleProductTypeChange,
            handleColorChange,
            handleProNameChange,
            handleSkuChange,
            handleBuyerChange,
            handleFinishChange,
            handleAliasChange,
            handleSearchChange,
            handleProDChange,
            handleMadeChange,
            handleHSNChange,
            handleMaterialChange,
            handleDatechange,
            handleUpdatedDatechange,

            //onopenfunctions
            fetchCategory,
            fetchColors,
            fetchFinishes,
            fetchProductTypes,
            fetchAlias,
            fetchHsn,
            fetchMaterials,
            //rendermenus
            renderMenu2,
            renderMenu5,
            renderMenu1,
            renderMenu,
            renderMenu3,
            renderMenu4
          }}
        />
        <Stack
          className="copyright"
          justifyContent="flex-end"
          spacing={5}
          style={{
            position: 'fixed',
            bottom: '0',
            width: '-webkit-fill-available',
            textAlign: 'center',
            backgroundColor: 'white',
            paddingRight: '16px'
          }}
        >
          <p>© All Right Reserved. Product by </p>
          <p>
            {' '}
            <a href="https://erpdaddy.com/" target="_blank">
              ERP Daddy Softwere Solution.
            </a>
          </p>
        </Stack>
      </Container>
    </>
  );
};
export default PriceList;
